export class SpotApiError extends Error {
    constructor(code, message, details = {}) {
        super(message);
        this.name = 'SpotApiError';
        this.code = code;
        this.details = details;
    }
}
